import React from 'react';
import { Button } from './ui/Button';
import { Calendar, Hammer, Rocket } from 'lucide-react';
import { motion } from 'framer-motion';
export function HowItWorksSection() {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section id="how-it-works" className="py-16 md:py-24 bg-white relative overflow-hidden" data-id="element-252">
      <div className="absolute inset-0 gradient-animated-subtle pointer-events-none" data-id="element-253" />
      <div className="container mx-auto px-4 relative z-10" data-id="element-254">
        <div className="text-center mb-12 md:mb-20" data-id="element-255">
          <h2 className="text-3xl md:text-4xl font-black text-black mb-3 md:mb-4" data-id="element-256">
            GO LIVE IN 3 SIMPLE STEPS
          </h2>
          <p className="text-lg md:text-xl text-gray-600" data-id="element-257">
            From Zero to Automated in Record Time
          </p>
        </div>

        <div className="relative" data-id="element-258">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-1 bg-gray-200 -translate-y-1/2 z-0" data-id="element-259">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: '100%'
          }} transition={{
            duration: 1.5,
            ease: 'easeOut'
          }} viewport={{
            once: true
          }} className="h-full bg-primary" data-id="element-260" />
          </div>

          <div className="grid md:grid-cols-3 gap-6 md:gap-12 relative z-10" data-id="element-261">
            {[{
            step: '01',
            icon: Calendar,
            title: 'Pick Your Plan',
            desc: 'Select Starter, Unlimited, or Pro based on your business needs. Fill out the quick form to begin.',
            sub: 'Takes 2 minutes'
          }, {
            step: '02',
            icon: Hammer,
            title: 'We Build It',
            desc: 'Our team designs your site, sets up your automations, and integrates everything seamlessly.',
            sub: 'Setup in 7-14 days'
          }, {
            step: '03',
            icon: Rocket,
            title: 'Start Earning',
            desc: 'Your systems go live. Watch as you save hours of manual work while capturing more leads and revenue.',
            sub: 'Cancel anytime'
          }].map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.7,
            delay: index * 0.2,
            ease: 'easeOut'
          }} viewport={{
            once: true
          }} className="bg-white border border-gray-200 p-6 md:p-8 rounded-xl md:rounded-2xl relative" data-id="element-262">
                <div className="absolute -top-5 md:-top-6 left-1/2 -translate-x-1/2 w-10 h-10 md:w-12 md:h-12 bg-primary rounded-full flex items-center justify-center text-white font-black text-sm md:text-base border-4 border-white shadow-lg z-20" data-id="element-263">
                  {item.step}
                </div>

                <div className="mt-6 md:mt-8 text-center" data-id="element-264">
                  <div className="bg-gray-50 w-12 h-12 md:w-16 md:h-16 rounded-full flex items-center justify-center mx-auto mb-4 md:mb-6 text-primary" data-id="element-265">
                    <item.icon size={24} className="md:w-8 md:h-8" data-id="element-266" />
                  </div>
                  <h3 className="text-lg md:text-xl font-bold text-black mb-2 md:mb-3" data-id="element-267">
                    {item.title}
                  </h3>
                  <p className="text-gray-600 text-xs md:text-sm mb-3 md:mb-4" data-id="element-268">
                    {item.desc}
                  </p>
                  <p className="text-primary text-[10px] md:text-xs font-bold uppercase tracking-wide" data-id="element-269">
                    {item.sub}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>

        <div className="mt-10 md:mt-16 text-center" data-id="element-270">
          <h3 className="text-xl md:text-2xl font-bold text-black mb-2" data-id="element-271">
            Ready to Automate Your Business?
          </h3>
          <p className="text-gray-500 italic mb-6 md:mb-8 text-sm md:text-base" data-id="element-272">
            Simple pricing. Powerful results. No long-term contracts.
          </p>
          <Button size="lg" onClick={scrollToContact} data-id="element-273">
            PICK YOUR PLAN NOW
          </Button>
        </div>
      </div>
    </section>;
}